// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__HFufv","logoContainer":"styles_logoContainer__2Mt8l","signUpContainer":"styles_signUpContainer__pKHAQ"};